import 'react-toastify/dist/ReactToastify.css'

import CookieConsent from 'react-cookie-consent'
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import React from 'react'
import { ToastContainer } from 'react-toastify'
import Track from './components/TrackTransfer/Track'
import AboutUs from './pages/AboutUs'
import EmailNotVerify from './pages/Accounts/EmailVerification/EmailNotVerify'
import EmailVerified from './pages/Accounts/EmailVerification/EmailVerified'
import ForgotPassword from './pages/Accounts/ForgotPassword/ForgotPassword'
import Login from './pages/Accounts/Login/Login'
import ChangePassword from './pages/Accounts/Profile/ChangePassword'
import MyProfile from './pages/Accounts/Profile/MyProfile'
import ResetPassword from './pages/Accounts/ResetPassword/ResetPassword'
import ResetPasswordConfirm from './pages/Accounts/ResetPassword/ResetPasswordConfirm'
import ResetPasswordFail from './pages/Accounts/ResetPassword/ResetPasswordFail'
import ResetPasswordRedirect from './pages/Accounts/ResetPassword/ResetPasswordRedirect'
import SignUp from './pages/Accounts/SignUp/SignUp'
import Contact from './pages/Contact/Contact'
import CookiePolicy from './pages/Cookies/CookiePolicy'
import Dashboard from './pages/Dashboard/Dashboard'
import AddRecipient from './pages/Dashboard/Recipents/AddRecipient'
import RecipientList from './pages/Dashboard/Recipents/RecipientList'
import TransactionDetails from './pages/Dashboard/TransferDetails/TransactionDetails'
import AddTransaction from './pages/Dashboard/Transfers/AddTransaction'
import TransactionList from './pages/Dashboard/Transfers/TransactionList'
import Faqs from './pages/Faqs'
import Home from './pages/Home/Home'
import NoPage from './pages/NoPage'
import TermsAndCondition from './pages/TermsAndCondition'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Career from './pages/Career'
import Invite from './pages/Accounts/Invite/Invite'
import EarlyBird from './pages/EarlyBird'
import Cred from './pages/cred'
import Register from './pages/Accounts/dfnsMobile/Register'
import WalletCreate from './pages/Accounts/dfnsMobile/WalletCreate'
import Verify from './pages/Accounts/dfnsMobile/Verify'
import StripeCheckoutForm from './pages/Dashboard/Checkout/StripeCheckout'
import { sendPageViewAnalytics } from './analytics'
import HardRecovery from './pages/Accounts/Profile/HardRecovery'
import MobileContact from './pages/Contact/MobileContact'
import AppRedirect from './pages/AppRedirect'

function App() {
  const [val, setVal] = useState('')
  const location = useLocation()
  useEffect(() => {
    sendPageViewAnalytics(location.path)
  }, [location])
  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/Login' element={<Login carry={setVal} />} />
        <Route path='/SignUp' element={<SignUp />} />
        <Route path='/Dashboard' element={<Dashboard />} />
        <Route path='/Transaction-List' element={<TransactionList />} />
        <Route
          path='/Add-Transaction'
          element={<AddTransaction send_amount={val} />}
        />
        <Route
          path='/Transaction-Details/:id'
          element={<TransactionDetails />}
        />
        <Route path='/Recipient-List' element={<RecipientList />} />
        <Route path='/Add-Recipient' element={<AddRecipient />} />
        <Route path='/Change-Password' element={<ChangePassword />} />
        <Route path='/myprofile' element={<MyProfile />} />
        <Route path='/Contact' element={<Contact />} />
        <Route path='/mobile-contact' element={<MobileContact />} />
        <Route path='/app-redirect' element={<AppRedirect />} />
        <Route path='/Track' element={<Track />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route
          path='/dfns/mobile/register/:token/:username'
          element={<Register />}
        />
        <Route
          path='/dfns/mobile/wallet-create/:token/:username'
          element={<WalletCreate />}
        />
        <Route
          path='/dfns/mobile/wallet-create/:token/:username/:id/:walletId'
          element={<Verify />}
        />

        <Route
          path='/Reset-Password-Redirect'
          element={<ResetPasswordRedirect />}
        />
        <Route path='/hard-recovery' element={<HardRecovery />} />
        <Route
          path='/Reset-Password-Confirm'
          element={<ResetPasswordConfirm />}
        />
        <Route path='/Reset-Password-Fail' element={<ResetPasswordFail />} />
        <Route path='/Email-Verified' element={<EmailVerified />} />
        <Route path='/Email-Not-Verify' element={<EmailNotVerify />} />
        <Route path='/invite' element={<Invite />} />
        <Route path='/Faqs' element={<Faqs />} />
        <Route path='/new-device' element={<Cred />} />

        <Route path='/terms-and-conditions' element={<TermsAndCondition />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/career' element={<Career />} />
        <Route path='/cookie-policy' element={<CookiePolicy />} />
        <Route path='/AboutUs' element={<AboutUs />} />
        <Route path='/EarlyBird' element={<EarlyBird />} />
        <Route path='/checkout/:transfer_id' element={<StripeCheckoutForm />} />
        <Route path='/*' element={<NoPage />} />
      </Routes>
      <ToastContainer />
      <CookieConsent
        enableDeclineButton
        flipButtons
        declineButtonText='Decline'
        buttonText='Accept'
        contentClasses='text-lg'
        buttonClasses='font-semibold'
        declineButtonClasses='font-semibold'
      >
        This website stores data such as cookies to enable essential site
        functionality, as well as marketing, personalisation, and analytics.{' '}
        <Link to='cookie-policy' className='text-blue-400'>
          Learn more
        </Link>
      </CookieConsent>
    </div>
  )
}

export default App
